import React from 'react'
import PreviousSSD from '../../sanityInterfaces/PreviousSSD';

interface contentProps {
    data: PreviousSSD;
}

const WorkshopsContent = (props: contentProps) => {
    return (
        <div className="p-4 my-4 grid gap-5 text-left space-y-2">
            {props?.data?.Workshops && props?.data.Workshops.map((item, index) => {
                return (
                    <div key={index}>
                        <h1 className='text-red-500 text-3xl font-semibold'>{item.Title}</h1>
                        <div className='border rounded-lg border-stale-200 p-4 mx-6'>
                            <h2 className='text-xl'><span className='font-bold'>Speaker - </span> {item.Speaker}</h2>
                            <p>
                                {item.Explanation[0].children[0].text}
                            </p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default WorkshopsContent